<template>
  <v-container fluid id="settlement-misc-payments">
    <v-row v-if="miscPayments.advances?.length > 0">
      <v-col>
        <SettlementAdvances
        :advances="miscPayments.advances"
        :isExportBatch="isExportBatch"
        :savedColumnsContext="savedColumnsContext"/>
      </v-col>
    </v-row>
    <v-row v-if="miscPayments.tractPayments?.length > 0">
      <v-col>
        <v-container fluid>
          <span class="title">{{ $t('tractPayments') }}</span>
          <DataTable
          :items="miscPayments.tractPayments"
          :headers="tractPaymentHeaders"
          :showSearch="false"/>
        </v-container>
      </v-col>
    </v-row>
    <v-row v-if="miscPayments.accountPayments?.length > 0">
      <v-col>
        <v-container fluid>
          <span class="title">{{ $t('accountPayments') }}</span>
          <DataTable
          :items="miscPayments.accountPayments"
          :headers="accountPaymentHeaders"
          :showSearch="false"
          :customCells="customCells">
            <template #actions="{item}">
              <Icon
              :disabled="!userAssignedClaim(UserClaims.AccountManager)"
              icon="mdi-delete-forever"
              iconColor="error"
              :tooltipText="$t('delete')"
              @icon-clicked="deletePayable(item)"/>
            </template>
            <template #note="{item}">
              <span>
                {{ item.note }}
                <Icon
                v-if="!!item.accountPayableTemplateId"
                icon="mdi-sync"
                :tooltipText="$t('recurring')"
                iconColor="black"
                tooltipColor="black"/>
              </span>
            </template>
          </DataTable>
        </v-container>
      </v-col>
    </v-row>
    <v-dialog v-model="deleteAccountPayable" v-if="confirmDelete" width="400">
      <ConfirmDialog
      v-if="confirmDelete"
      :title="$t('deleteAccountPaymentTitle')"
      :body="$t('deleteAccountPaymentBody')"
      @cancel="closeDialogs"
      @confirm="handleConfirmDelete"/>
    </v-dialog>
  </v-container>
</template>

<script>
import { ContractMode, UserClaims } from '@/utils/Enumerations'
import { settlementTractPaymentHeaders, settlementAccountPaymentHeaders } from '@/headers/ExportBatch.js'
import { SettlementKeys, SettlementSubKeys } from '@/components/settlements/SettlementKeys.js'
import { mapGetters, mapActions } from 'vuex'
import { userAssignedClaim } from '@/utils/ClaimUtility'
export default {
  name: 'MiscSettlementPayments',

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue'),
    SettlementAdvances: () => import('@/components/settlements/accounts-payable-module/other-modules/SettlementAdvances.vue'),
    Icon: () => import('@/components/helper/Icon.vue'),
    ConfirmDialog: () => import('@/components/helper/ConfirmDialog.vue')
  },

  props: {
    miscPayments: {
      type: Object,
      required: true
    },
    isExportBatch: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    ContractMode,
    UserClaims,
    focusedAccountPayment: undefined,
    confirmDelete: false,
    customCells: [
      {
        slotName: 'actions',
        value: 'actions'
      },
      {
        slotName: 'note',
        value: 'note'
      }
    ]
  }),

  computed: {
    ...mapGetters('settlements', ['dateConfiguration', 'currentModuleKey', 'currentSubModuleKey']),

    savedColumnsContext () {
      if (this.currentModuleKey !== SettlementKeys.AccountsPayable) return undefined
      return this.currentSubModuleKey === SettlementSubKeys.AP.MiscPayments ? this.currentSubModuleKey : undefined
    },

    tractPaymentHeaders () {
      return settlementTractPaymentHeaders(this.savedColumnsContext).getColumns()
    },

    accountPaymentHeaders () {
      return settlementAccountPaymentHeaders(this.savedColumnsContext).getColumns()
    }
  },

  methods: {
    ...mapActions('account', ['deleteAccountPayable']),
    ...mapActions('settlements', ['clearStaleSubModuleData', 'refreshModuleData']),
    userAssignedClaim,

    deletePayable (item) {
      if (this.dateConfiguration.exportBatch?.exportBatchId !== undefined) {
        this.setSnackError(this.$t('cannotEditOrDeleteExportedAccountPayments'))
        return
      }
      this.focusedAccountPayment = item
      this.confirmDelete = true
    },

    closeDialogs () {
      this.focusedAccountPayment = undefined
      this.confirmDelete = false
    },

    async handleConfirmDelete () {
      await this.deleteAccountPayable({
        accountId: this.focusedAccountPayment.accountId,
        accountPayableId: this.focusedAccountPayment.accountPayableId
      })
      this.closeDialogs()
      await this.refreshModuleData(false)
      this.clearStaleSubModuleData({ isByproduct: false })
    }
  }
}
</script>
